<template>
    <svg class="svg" viewBox="0 0 388 194" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M167.841 185.914L5.15331 75.6105C1.94529 73.4154 0 69.7798 0 65.8698V4.02981C0 0.805757 3.58343 -1.11493 6.2454 0.702884L187.465 123.594C191.423 126.269 196.611 126.269 200.535 123.594L381.755 0.702884C384.417 -1.11493 388 0.805757 388 4.02981V65.8698C388 69.7798 386.055 73.4154 382.847 75.6105L220.159 185.948C204.324 196.684 183.642 196.684 167.807 185.948L167.841 185.914Z"
            fill="#0032FF"
        />
    </svg>
</template>

<style lang="less" scoped>
    .svg {
        height: .convert(194px) [ @vw];
    }
</style>
